module.exports = __webpack_public_path__ + "static/AboutSkills-f1b1b2a805efa1081247906750c6cb91.png";